// src/lib/uebersetzungen/hr-info.js
// Kroatische (gekuerzte) i-Texte, aus zwei Teilen zusammengesetzt.
import { INFO_HR_TEIL1, MODUL_INFO_HR_TEIL1 } from './hr-info-teil1';
import { INFO_HR_TEIL2, MODUL_INFO_HR_TEIL2 } from './hr-info-teil2';

export const INFO_HR = { ...INFO_HR_TEIL1, ...INFO_HR_TEIL2 };
export const MODUL_INFO_HR = { ...MODUL_INFO_HR_TEIL1, ...MODUL_INFO_HR_TEIL2 };
